{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.DataGrid.Common;

interface
uses
  Classes, SysUtils;


type
{$REGION 'Enums'}
TDGCellRendererType = (
  crtDefault,
  crtText,
  crtImage,
  crtURL,
  crtEmail,
  crtTel,
  crtCustom,
  crtCheckbox
);
TDGCellEditorType = (
  cetDefault,
  cetText,
  cetNumber,
  cetDate,
  cetTime,
  cetRange,
  cetColor,
  cetWeek,
  cetMonth,
  cetURL,
  cetEmail,
  cetTel,
  
  cetMemo,
  cetNone,
  cetCustom,
  cetCheckbox,
  cetCombobox,
  cetDateTime
);
TDGCellDataType = (
  cdtText,
  cdtNumber,
  cdtBoolean,
  cdtDate,
  cdtDateString,

  cdtObject
);

TDGBuiltInThemes = (
  agThemeAlpine,
  agThemeBalham,
  agThemeMaterial,
  agThemeQuartz,
  agThemeCustom
  );
TDGBuiltInThemeMode = (
  agLightMode,
  agDarkMode,
  agAutoDarkMode
  );

{$ENDREGION}

{$IFDEF PAS2JS}
  // The PAS2JS compiler doesn't know what TJSValue
  TJSValue = JSValue;
{$ELSE}
  // PAS2JS Types
  TJSSyntaxError = Exception;
{$ENDIF}

implementation

end.
